import angular from 'angular';
import moment from 'moment';
import { IApontamentoTrabalhador, IApontamentoTrabalhadorCreate } from '../models/apontamentostrabalhadores.model';
import { ModalConfirmService } from '../../../shared/components/modal-confirm/modal.confirm.service';

export class ApontamentosTrabalhadoresModalController {
    static $inject = [
        '$uibModalInstance',
        '$rootScope',
        '$scope',
        'entity',
        'apontamentosTrabalhadores',
        'periodoApuracao',
        'visualizacao',
        'NewToaster',
        'ModalConfirmService',
    ];

    public submitted = false;
    public form: angular.IFormController;

    public dataPagamentoConfig = false;

    constructor(
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public $rootScope: angular.IRootScopeService & {
            currentDate: moment.Moment,
            nsjGlobals: any,
        },
        public $scope: angular.IScope,
        public entity: IApontamentoTrabalhadorCreate,
        public apontamentosTrabalhadores: IApontamentoTrabalhador[],
        public periodoApuracao: IApontamentoTrabalhadorCreate['periodoapuracao'],
        public visualizacao: boolean,
        public NewToaster: { pop: Function },
        public ModalConfirmService: ModalConfirmService
    ) {
        const dataInicio = moment(periodoApuracao.datainicial, 'YYYY-MM-DD').startOf('day');
        const dataFim = moment(periodoApuracao.datafinal, 'YYYY-MM-DD').startOf('day');
        const currentDate = $rootScope.currentDate.startOf('day');
        entity.periodoapuracao = {
            datainicial: dataInicio,
            datafinal: (dataFim.isAfter(currentDate)) ? $rootScope.currentDate : dataFim
        };
        this.dataPagamentoConfig = this.$rootScope.nsjGlobals.a.configuracoes.MOVIMENTO_DATAPAGAMENTO ? true : false;
    }

    submit() {
        let sem_erro_limite_movimento = true;
        if (Array.isArray(this.entity.movimentos) && this.entity.movimentos.length) {
            this.entity.movimentos.forEach(i => {
                if (
                    i.evento.evento_unidade &&
                    (i.evento.evento_unidade !== 0 && i.evento.evento_unidade !== 1 && i.evento.evento_unidade !== 2
                    && i.evento.evento_unidade !== 8 && i.evento.evento_unidade !== 10) &&
                    !this.entity.movimentos.some(this.unidadeEvento)
                ) {
                    sem_erro_limite_movimento = true;
                } else if (
                    (i.conteudo === null || i.conteudo === '' || i.evento === null) &&
                    (!i.evento.evento_unidade || (i.evento.evento_unidade === 0 || i.evento.evento_unidade === 1 ||
                    i.evento.evento_unidade === 2 || i.evento.evento_unidade === 8 || i.evento.evento_unidade === 10))
                ) {
                    sem_erro_limite_movimento = false;
                    this.NewToaster.pop({
                        type: 'error',
                        title: 'Erro no cadastramento da rubrica.',
                        body: 'Não é possível cadastrar um apontamento com uma rubrica vazia.'
                    });
                }
            });

            if (this.entity.movimentos.some(this.lotacoesVazias)) {
                sem_erro_limite_movimento = false;
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro no cadastramento da rubrica.',
                    body: 'Não é possível cadastrar um apontamento com uma rubrica sem lotação.'
                });
            }
            if (!(this.entity.trabalhador !== undefined)) {
                sem_erro_limite_movimento = false;
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro no cadastramento da rubrica.',
                    body: 'Não é possível cadastrar um apontamento com o colaborador vazio.'
                });
            }
            if (this.entity.movimentos.some(this.validarValorRubricas)) {
                sem_erro_limite_movimento = false;
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Não é possível adicionar uma rubrica cujo valor excede o limite.'
                });
            }
        } else {
            sem_erro_limite_movimento = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'É preciso adicionar pelo menos uma rubrica'
            });
        }

        if (sem_erro_limite_movimento) {
            this.submitted = true;

            if (this.form.$invalid) {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Alguns campos do formulário apresentam erros'
                });
                return;
            }

            const fecharModal = () => {
                this.entity.$__loaded = true;
                this.$uibModalInstance.close(this.entity);
            };

            const temMovimentosDuplicados = this.temDuplicatas(this.entity.movimentos, [
                'evento.evento',
                'lotacao.lotacao',
                'conteudo',
                ...(this.dataPagamentoConfig ? ['datapagamento'] : [])
            ]);

            if (temMovimentosDuplicados) {
                this.confirmaRubricasDuplicadas()
                    .then(fecharModal).catch(() => {/**/});
                return;
            }

            fecharModal();
        }
    }

    close() {
        this.$uibModalInstance.dismiss('fechar');
    }

    lotacoesVazias(elemento: any, index: any, array: any) {
        return (elemento.lotacao == null) ? true : false;
    }

    unidadeEvento(elemento: any, index: any, array: any) {
        return (elemento.evento.evento_unidade === 0 || elemento.evento.evento_unidade === 1 || elemento.evento.evento_unidade === 2 ||
            elemento.evento.evento_unidade === 8 || elemento.evento.evento_unidade === 10) ? true : false;
    }

    // essa função é usada no Array.prototype.some
    validarValorRubricas(elemento: any, index: any, array: any) {
        let valorRubrica = elemento.conteudo;
        let limiteerro = elemento.evento.limiteerro;
        return limiteerro > 0 ? valorRubrica > limiteerro : false;
    }

    temRubricasDuplicadas() {
        if (!this.entity || !this.entity.movimentos) {
            return;
        }

        const rubricas = this.entity.movimentos.map((movimento) => movimento.evento.codigo);
        const temDuplicadas = new Set(rubricas).size !== rubricas.length;

        return temDuplicadas;
    }

    temDuplicatas(arr: unknown[], props: string[]) {
        if (!Array.isArray(arr) || arr.length <= 1) {
            return false;
        }

        const vistos = new Set<string>();

        for (const item of arr) {
            // cria uma "chave" única com base nas propriedades desejadas
            const chave = props.map(path => {
                const valor = this.getValorPorPath(item, path);

                if (typeof valor === 'number') {
                    return Number(valor).toString();
                }

                if (typeof valor === 'string' && !isNaN(Number(valor))) {
                    return Number(valor).toString();
                }

                return String(valor ?? '').trim().toLowerCase();
            }).join('|');

            if (vistos.has(chave)) {
                return true; // encontrou duplicata
            }

            vistos.add(chave);
        }

        return false; // sem duplicatas
    }

    getValorPorPath(obj: unknown, path: string) {
        return path.split('.').reduce((acc, key) => {
            if (acc && typeof acc === 'object') {
                return acc[key];
            }
            return undefined;
        }, obj);
    }

    confirmaRubricasDuplicadas() {
        const baseText = 'Detectamos que já existem movimentos com dados iguais de rubrica, valor';
        const subtitle = `${baseText}${this.dataPagamentoConfig ? ', lotação e data de pagamento' : ' e lotação'} para o colaborador.`;
        const text = {
            title: 'Confirmar movimentos',
            subtitle,
            confirmText: 'Deseja salvar o rascunho mesmo assim?',
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
        };
        const confirm = this.ModalConfirmService.open(this.entity, 'Movimentos', false, text);
        return confirm.result;
    }
}
